import { z } from 'zod';
import { Channel } from '.';

export const BuySellOrderChannelSchema = {
  metricsUpdated: z.object({
    orderRevenue: z.number().default(0),
    arExpenses: z.number().default(0),
    totalRevenue: z.number().default(0),
    totalCogs: z.number().default(0),
    apExpenses: z.number().default(0),
    grossProfit: z.number().default(0),
    netProfit: z.number().default(0),
    grossProfitMargin: z.number().default(0),
    netProfitMargin: z.number().default(0),
    units: z.number().default(0),
    weight: z.number().default(0),
    pallets: z.number().default(0),
    unitsInvoiced: z.number().default(0),
    weightInvoiced: z.number().default(0),
    palletsInvoiced: z.number().default(0),
  }),
  // Bare ping, same contract as SalesOrderChannel.expensesUpdated: data-free on purpose.
  expensesUpdated: z.object({ buySellOrderId: z.number() }),
} as const;

export const BuySellOrderChannel: Channel<number, typeof BuySellOrderChannelSchema> = {
  getChannelId: (id) => `buySellOrder:${id}`,
  topics: { metricsUpdated: 'metricsUpdated', expensesUpdated: 'expensesUpdated' },
  schemas: BuySellOrderChannelSchema,
};
